var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list_once" }, [
      _c("p", { staticClass: "p" }, [_vm._v("如何使用模板发起签约")]),
      _c("p", { staticClass: "text" }, [
        _vm._v("1.在首页中点击“授权给我的模板”进入我的模板页面；")
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img5.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "2.点击立即发起（若无模板请先进入企业控制台进行创建，创建完成后授权给需要使用的成员）；"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img6.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bc9c24d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc9c24d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/helpCenterCom/2_tempSign.vue
// module id = D/wD
// module chunks = 54 242